const academiesPath = '/academies';
export const getAcademies = (availableCountries: string, status = 'all') => `${academiesPath}?&status=${status}&availableCountries=${availableCountries}&dataSource=wdc`;
export const getAcademyById = (id: number) =>
  `${academiesPath}/${id}?&dataSource=local`;
export const createAcademy = `${academiesPath}`;
export const updateAcademy = (id: number) =>
  `${academiesPath}/${id}?&dataSource=local`;
export const updateAcademyStatus = (id: number) =>
  `${academiesPath}/${id}/activation?&dataSource=local`;
export const getWdcSports = '/wdcAcademies';
